import React, { ReactElement } from 'react';
import { observer } from 'mobx-react-lite';
import { Helmet } from 'react-helmet';
import parse from 'html-react-parser';
import { styled } from '@linaria/react';
import { ArticleWrapper } from '@rambler-help/components';
import {
  fontMontserrat,
  fontColorDefault,
  WrapperStyles,
  RightColumnStyles
} from '@rambler-help/shared';

import { Popular } from '@components/Popular';
import { Back } from '@components/Back';
import { ScrollUp } from '@components/ScrollUp';
import { useRootStore } from '@stores/index';
import { SITE_TITLE } from '@constants/meta';
import { parserOptions } from '@helpers/parserOptions';

const ProjectPageStyled = styled.div`
  ${WrapperStyles}
  h1 {
    margin: 30px 0 20px;
    ${fontMontserrat}
    ${fontColorDefault}
    font-size: 26px;
    line-height: 30px;
    font-weight: 800;
  }
  h2 {
    margin: 30px 0;
    ${fontMontserrat}
    ${fontColorDefault}
    font-size: 38px;
    line-height: 45px;
    font-weight: 800;
  }
`;
const Content = styled.div`
  ${RightColumnStyles}
`;
const Description = styled.div`
  margin-bottom: 20px;
`;

const LEGAL_DOCUMENTS_PROJECT_ID = 69;

export const Project = observer((): ReactElement => {
  const { projects } = useRootStore();

  return (
    <>
      <Helmet>
        <title>{`${projects?.project?.title} — ${SITE_TITLE}`}</title>
      </Helmet>
      <ProjectPageStyled>
        <Content>
          <Back to={'/'}>Все сервисы Рамблера</Back>
          {projects?.project?.id === LEGAL_DOCUMENTS_PROJECT_ID ? (
            <h2>{projects?.project?.title}</h2>
          ) : (
            <>
              <h2>Помощь по проекту «{projects?.project?.title}»</h2>
              <Popular />
              <h1>О проекте «{projects?.project?.title}»</h1>
            </>
          )}
          <Description>
            <ArticleWrapper>
              {projects?.project?.description ? parse(projects?.project?.description, parserOptions) : null}
            </ArticleWrapper>
          </Description>
          <ScrollUp />
        </Content>
      </ProjectPageStyled>
    </>
  );
});
